import { Outlet, Route, Routes } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import { EmpresasListWrapper } from './empresas-list/EmpresasList'
import { ClientesListWrapper } from './clientes-contratos-list/ClientesList'
import { useT } from '../../../../_metronic/i18n/Metronici18n'
import { EmpresaValoresListWrapper } from './empresa-valores-list/EmpresaValoresList'

const EmpresasPage = () => {
  const { t } = useT()
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Instituições',
      path: '/apps/empresas',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path=''
          element={
            <>
              <PageTitle description={t('pagina.empresa.descricao')}>
                {t('empresa.label')}
              </PageTitle>
              <EmpresasListWrapper />
            </>
          }
        />
        <Route
          path='financeiro/:id'
          element={
            <>
              <PageTitle breadcrumbs={breadCrumbs}>Valores</PageTitle>
              <EmpresaValoresListWrapper />
            </>
          }
        />
        <Route
          path='clientes'
          element={
            <>
              <PageTitle description={t('pagina.entidade.descricao')}>
                {t('entidade.label')}
              </PageTitle>
              <ClientesListWrapper />
            </>
          }
        />
        <Route
          path='clientes/:id'
          element={
            <>
              <PageTitle description={t('pagina.entidade.descricao')}>
                {t('entidade.label')}
              </PageTitle>
              <ClientesListWrapper />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export default EmpresasPage
